<template>
    <div>
        <b-alert variant="info" show>
            <b-row>
                <b-col cols="1" sm="2"	md="2"	lg="2"	xl="2">
                    <b-form-select v-model="selected" :options="options"/>
                </b-col>
                <b-col v-if="selected === 2" cols="1" sm="2"	md="2"	lg="2"	xl="2">
                    <b-form-input v-model="searchnombre" placeholder="Ingrese descripcion del producto"/>
                </b-col>
                <b-col cols="1" sm="2"	md="2"	lg="2"	xl="5">
                    <b-form inline>
                        Desde:
                        <DatePicker v-model="f1" type="datetime" format="DD/MM/YYYY hh:mm A" value-type="YYYY-MM-DD HH:mm:ss" placeholder="Elige fecha desde"/>
                        Hasta:
                        <DatePicker v-model="f2" type="datetime" format="DD/MM/YYYY hh:mm A" valueType="YYYY-MM-DD HH:mm:ss" placeholder="Elige fecha hasta"/>
                    </b-form>
                </b-col>
                <b-col cols="1" sm="2"	md="2"	lg="2"	xl="2">
                    <b-button @click.prevent="selectorRuta" variant="success">Buscar</b-button>
                </b-col>
                <b-col v-if="selected === 3" cols="1" sm="2"	md="2"	lg="2"	xl="2">
                    <!-- :disabled="!Boolean(f1!='' && f2!='')" -->
                    <b-button v-if="!loadingexcelreport" variant="primary" @click="downloadReportExcel(1)"><i class="fa fa-file-excel"/> Reporte detallado de ventas</b-button>
                    <b-button v-else variant="secondary"><i class="fa fa-spin fa-spinner"/> Procesando</b-button>
                </b-col>
                <b-col v-if="selected === 6" cols="1" sm="2"	md="2"	lg="2"	xl="2">
                    <!-- :disabled="!Boolean(f1!='' && f2!='')" -->
                    <b-button v-if="!loadingexcelreport" variant="primary" @click="downloadReportExcel(2)"><i class="fa fa-file-excel"/> Reporte detallado de Guias</b-button>
                    <b-button v-else variant="secondary"><i class="fa fa-spin fa-spinner"/> Procesando</b-button>
                </b-col>
                <b-col v-if="selected === 9" cols="1" sm="2"	md="2"	lg="2"	xl="2">
                    <!-- :disabled="!Boolean(f1!='' && f2!='')" -->
                    <b-button v-if="!loadingexcelreport" variant="primary" @click="downloadReportExcel(3)"><i class="fa fa-file-excel"/> Reporte detallado de Proformas</b-button>
                    <b-button v-else variant="secondary"><i class="fa fa-spin fa-spinner"/> Procesando</b-button>
                </b-col>
            </b-row>
        </b-alert>
        <b-row>
            <b-col cols="12" sm="10" md="10"	lg="10"	xl="5">
                <b-form-group label-cols="3" label="Filtrar por Campo" class="mb-0">
                <b-input-group>
                    <b-form-input v-model="filter" placeholder="Ingresa tu Busqueda" />
                    <b-input-group-append>
                    <b-btn :disabled="!filter" @click="filter = ''">Limpiar</b-btn>
                    </b-input-group-append>
                </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" sm="2"	md="2"	lg="2"	xl="1">
                <b-button variant="secondary" @click="selectorRuta"><i class="fa fa-sync-alt"/> </b-button>
            </b-col>
            <br><br>
            <b-col cols="6" sm="6"	md="6"	lg="7"	xl="3">
                <b-form-group label-cols="2" label="Orden" class="mb-0">
                    <b-input-group>
                    <b-form-select v-model="orden" slot="append" @input="selectorRuta">
                        <option :value="'asc'">Más Antiguo</option>
                        <option :value="'desc'">Más Reciente</option>
                    </b-form-select>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6" sm="6"	md="6"	lg="5"	xl="3">
                <b-form-group label-cols="2" label="Mostrar" class="mb-0">
                    <b-input-group>
                        <b-form-select v-model="limite" slot="append" @input="selectorRuta">
                        <option :value="10">10</option>
                            <option :value="25">25</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                        </b-form-select>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row><hr>
        <b-row>
            <b-col v-if="selected == 1 || selected == 2 | selected == 3" cols="12" sm="12"	md="12"	lg="12"	xl="12" class="text-center">
                <h6><b>Reporte de productos vendidos
                    desde {{ f1===''? $moment().format("DD/MM/YYYY hh:mm A") : $moment(f1).format("DD/MM/YYYY hh:mm A") }}
                    hasta {{ f2==='' ? $moment().format("DD/MM/YYYY hh:mm A") : $moment(f2).format("DD/MM/YYYY hh:mm A") }}
                </b></h6>
            </b-col>
            <b-col v-if="selected == 4 || selected == 5 | selected == 6" cols="12" sm="12"	md="12"	lg="12"	xl="12" class="text-center">
                <h6><b>Reporte de Guias Emitidas
                    desde {{ f1===''? $moment().format("DD/MM/YYYY hh:mm A") : $moment(f1).format("DD/MM/YYYY hh:mm A") }}
                    hasta {{ f2==='' ? $moment().format("DD/MM/YYYY hh:mm A") : $moment(f2).format("DD/MM/YYYY hh:mm A") }}
                </b></h6>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-table v-if="tabtable === 1"
                    striped
                    hover
                    small
                    outlined
                    :filter="filter"
                    :current-page="pactual"
                    :per-page="limite"
                    :busy="isBusy"
                    :items="items"
                    :fields="items_fields"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    @filtered="onFiltered"
                    >
                    <div slot="table-busy" class="text-center">
                        <h3><i class="fas fa-spin fa-spinner"></i>Cargando...</h3>
                    </div>
                    <template slot="codigo" v-if="row.item.producto" slot-scope="row">
                        {{ row.item.producto.codigo }}
                    </template>
                    <template slot="medida" v-if="row.item.producto" slot-scope="row">
                        {{ row.item.producto.unidadMedida}}
                    </template>
                    <template slot="total" slot-scope="row">
                        <div class="text-right" v-if="row.item.total">
                            {{row.item.total.toFixed(2)}}
                        </div>
                    </template>
                </b-table>
                <b-table v-if="tabtable === 2"
                    striped
                    hover
                    small
                    outlined
                    :filter="filter"
                    :current-page="pactual"
                    :per-page="limite"
                    :busy="isBusy"
                    :items="items"
                    :fields="listavendidos_fields"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    @filtered="onFiltered"
                    >
                    <div slot="table-busy" class="text-center">
                        <h3><i class="fas fa-spin fa-spinner"></i>Cargando...</h3>
                    </div>
                    <template slot="fecha" slot-scope="row">
                        {{ $moment(row.item.created_at).format("DD/MM/YYYY hh:mm:ss A") }}
                    </template>
                    <template slot="codigo" v-if="row.item.producto" slot-scope="row">
                        {{ row.item.producto.codigo }}
                    </template>
                    <template slot="receptor" slot-scope="row" v-if="row.item.infoDocumento && row.item.infoDocumento.idReceptor">
                        {{ row.item.infoDocumento.idReceptor }}
                    </template>
                    <template slot="documento" slot-scope="row" v-if="row.item.infoDocumento && row.item.infoDocumento.serie && row.item.infoDocumento.numero">
                        {{ row.item.infoDocumento.serie }}-{{ row.item.infoDocumento.numero }}
                    </template>
                    <template slot="venta" slot-scope="row" v-if="row.item.infoDocumento && row.item.valorVenta && row.item.infoDocumento.tipoMoneda">
                        <div class="text-right">
                            <template v-if="row.item.infoDocumento.tipoMoneda==='PEN'">S/</template>
                            <template v-else-if="row.item.infoDocumento.tipoMoneda==='USD'">$</template>
                            <template v-else>{{ row.item.infoDocumento.tipoMoneda }}</template>
                            {{row.item.valorVenta.toFixed(2)}}
                        </div>
                    </template>
                </b-table>
                <b-table v-if="tabtable === 3"
                    :items="items"
                    :fields="items_guias"
                    small
                    responsive
                    outlined
                    :busy="isBusy">
                    <div slot="table-busy" class="text-center">
                        <h3><i class="fas fa-spin fa-spinner"></i>Cargando...</h3>
                    </div>
                </b-table>
                <b-table v-if="tabtable === 4"
                    :items="items"
                    :fields="items_lista_guias"
                    small
                    responsive
                    outlined
                    :busy="isBusy">
                    <div slot="table-busy" class="text-center">
                        <h3><i class="fas fa-spin fa-spinner"></i>Cargando...</h3>
                    </div>
                    <template v-if="row.item.info_documento && row.item.info_documento.serie" slot="documentoguia" slot-scope="row">
                        {{row.item.info_documento.serie}} - {{row.item.info_documento.numero}}
                    </template>
                     <template v-if="row.item.info_documento && row.item.info_documento.idReceptor" slot="receptor" slot-scope="row">
                        {{row.item.info_documento.idReceptor}}
                    </template>
                    <template slot="fecha" slot-scope="row">
                        {{$moment(row.item.created_at).format("DD/MM/YYYY hh:mm:ss A")}}
                    </template>
                </b-table>
                <b-table v-if="tabtable === 7"
                :items="items"
                :fields="items_lista_proformas"
                small
                responsive
                outlined
                :busy="isBusy">
                <div slot="table-busy" class="text-center">
                    <h3><i class="fas fa-spin fa-spinner"></i>Cargando...</h3>
                </div>
                <template slot="precioUnitario" slot-scope="row">
                    <div v-if="row.item.producto && row.item.producto !=''">
                       {{row.item.producto.precioUnitario}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="codigo" slot-scope="row">
                    <div v-if="row.item.producto && row.item.producto !=''">
                        {{row.item.producto.codigo}}
                    </div>
                    <div v-else>
                         -
                    </div>
                </template>
                <template slot="stock" slot-scope="row">
                    <div v-if="row.item.producto && row.item.producto !=''">
                      {{row.item.producto.stock}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="unidadMedida" slot-scope="row">
                    <div v-if="row.item.producto && row.item.producto !=''">
                      {{row.item.producto.unidadMedida}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                </b-table>
                <b-table v-if="tabtable === 9"
                :items="items"
                :fields="items_lista_detalladoproformas"
                small
                responsive
                outlined
                :busy="isBusy">
                <template slot="index" slot-scope="row">
                    {{ row.index }}
                </template>
                <div slot="table-busy" class="text-center">
                    <h3><i class="fas fa-spin fa-spinner"></i>Cargando...</h3>
                </div>
                <template slot="idReceptor" slot-scope="row">
                    <div>{{row.item.infoDocumento.proforma.receptor.nro}}</div>
                </template>
                <template slot="documento" slot-scope="row">
                    {{row.item.infoDocumento.serie}} - {{row.item.infoDocumento.numero}}
                </template>
                <template slot="precioUnitario" slot-scope="row">
                    <div v-if="row.item.infoDocumento.proforma.items && row.item.infoDocumento.proforma.items.length > 0">
                        {{itemsPrecioUni(row.item).toFixed(2)}}
                    </div>
        
                </template>
                <template slot="codigo" slot-scope="row">
                  <div v-if="row.item.producto && row.item.producto!=''">{{row.item.producto.codigo}}</div>
                  <div v-else> - </div>
                </template>
                <template slot="unidadMedidaItem" slot-scope="row">
                    <!-- <div v-if="row.item.infoDocumento.proforma.items && row.item.infoDocumento.proforma.length > 0">
                        {{row.item.infoDocumento.proforma.items[row.index].unidadMedidaCantidad}}
                    </div> -->
                    <!-- <div v-for="(item, index) of row.item.infoDocumento.proforma.items" :key="index">{{item.unidadMedidaCantidad}}</div> -->
                </template>
                <!-- <template slot="total" slot-scope="row">
                    {{row.item.infoDocumento.proforma.totales.importeTotal}}
                </template> -->
                <template slot="stock" slot-scope="row">
                    <div v-if="row.item.producto && row.item.producto!=''">{{row.item.producto.stock}}</div>
                    <div v-else> - </div>
                </template>
                </b-table>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12"	sm="4"	md="6"	lg="8"	xl="8">
                <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
            </b-col>
            <b-col cols="12"	sm="8"	md="6"	lg="4"	xl="4">
                <b-pagination size="sm" :total-rows="total" v-model="currentPage" :per-page="limite" @input="selectorRuta"/>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import axios from 'axios'
import download from 'downloadjs'
import DatePicker  from 'vue2-datepicker'
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
export default {
        name: '',
        components: {
            DatePicker
        },
        data: () => {
            return {
                time2: null,
                loadingexcelreport: false,
                tabtable: 1,
                selected: 1,
                options: [
                    { value: 1, text: 'Consolidado por código' },
                    { value: 2, text: 'Busqueda por nombre' },
                    { value: 3, text: 'Reporte detallado de ventas' },
                    { value: 4, text: 'Consolidado por código (Guia)' },
                    { value: 5, text: 'Busqueda por nombre (Guia)' },
                    { value: 6, text: 'Reporte detallado de ventas (Guia)' },
                    { value: 7, text: 'Consolidado por código (Proforma)' },
                    { value: 8, text: 'Busqueda por nombre (Proforma)' },
                    { value: 9, text: 'Reporte detallado de ventas (Proforma)'},
                ],
                items: [],
                items_fields: [
                    {key: 'codigo', label: 'Código', sortable: true},                   
                    {key: 'descripcion', label: 'Descripcion', sortable: true},
                    {key: 'cantidad', label: 'Cantidad', sortable: true},
                    {key: 'total', label: 'Total sin IGV', sortable: false}
                ],
                listavendidos_fields: [
                    {key: 'fecha', label: 'Fecha Creacion', sortable: true},
                    {key: 'codigo', label: 'Codigo', sortable: true},
                    {key: 'descripcion', label: 'Descripcion', sortable: true},
                    {key: 'documento', label: 'Documento', sortable: false},
                    {key: 'receptor', label: 'Receptor', sortable: false},
                    {key: 'cantidad', label: 'Cantidad', sortable: false},
                    {key: 'valorVenta', label: 'V. Venta', sortable: false},
                ],
                items_guias:[
                    {key:'idProducto', label:'Código'},
                    {key:'cantidad', label:'Cantidad'},
                    {key:'descripcion', label:'Descripción'},
                    {key:'info_documento', label:'info. Documento'},
                ],
                items_lista_guias:[
                    {key:'documentoguia', label:'Documento'},
                    {key:'receptor', label:'Receptor'},
                    {key:'fecha', label:'Fecha Emisión'},
                    {key:'idProducto', label:'Código'},
                    {key:'cantidad', label:'Cantidad'},
                    {key:'descripcion', label:'Descripcion'}         
                ],
                items_lista_proformas:[
                    {key:'codigo', label:'Código'},
                    {key:'descripcion', label:'Descripción'},
                    {key:'cantidad', label:'Cantidad'},
                    {key:'precioUnitario', label:'Precio Unitario'},
                    {key:'total', label:'Precio sin IGV'},
                    {key:'stock', label:'Stock'},
                    {key:'unidadMedida', label:'Unidad Medida'}         
                ],
                items_lista_detalladoproformas:[
                    {key:'index', label:'Index'},
                    {key:'documento', label:'Documento'},
                    {key:'idEmisor', label:'Emisor'},
                    {key:'idReceptor', label:'Receptor'},
                    {key:'descripcion', label:'Descripción'},
                    // {key:'unidadMedidaItem', label:'Unidad Medida'},
                    {key:'codigo', label:'Código'},
                    {key:'cantidad', label:'Cantidad'},
                    {key:'precioUnitario', label:'Precio Unitario'},
                    {key:'valorVenta', label:'Precio sin IGV'},
                    {key:'stock', label:'Stock'},
                    // {key:'total', label:'Total'},
                ],
                isBusy: false,
                cargandoconteo: false,
                filter: null,
                pactual: 1,
                limite: 10,
                orden: 'desc',
                total: 0.00,
                desde: 0,
                hasta: 0,
                totalRows: null,
                currentPage: 1,
                searchnombre: '',
                sortBy: null,
                sortDesc: false,
                sortDirection: 'asc',
                f1: '',
                f2: '',
                currentdate: ''
            }
        },
        mounted() {
           this.selectorRuta();
           this.initDates()
        },
        watch: {
            selected: function () {
               this.selectorRuta()
            }   
        },
        methods: {
            downloadReportExcel: function (value) {
                let date1;
                let date2;
                let file = '';
                this.f1==='' ? date1 = this.$moment().format('YYYY-MM-DD HH:mm:ss'): date1 = this.$moment(this.f1).startOf('day').format('YYYY-MM-DD HH:mm:ss');
                this.f2==='' ? date2 = this.$moment().format('YYYY-MM-DD HH:mm:ss'): date2 = this.$moment(this.f2).endOf('day').format('YYYY-MM-DD HH:mm:ss');
                // let date1 = this.$moment(this.f1).startOf('day').format('YYYY-MM-DD HH:mm:ss')
                // let date2 = this.$moment(this.f2).endOf('day').format('YYYY-MM-DD HH:mm:ss')
                let tag = document.createElement('i');
                tag.classList.add('fa','fa-spin', 'fa-spinner');
                let name = 'Reporte detallado de ventas ' + date1 + '-' + date2 + '.xlsx';
                this.loadingexcelreport = true;
                this.$swal({
                    title: 'Procesando Reporte',
                    content: tag,
                    icon: 'info',
                    buttons: false,
                    dangerMode: false
                });
                let ruta = ''
                if(value == 1){
                    ruta = 'reporteitem/listavendidos/excel'
                }else if(value == 2){
                    ruta = 'reporteitemguia/listavendidos/excel'
                }else if(value == 3){
                    ruta = 'reporteitem/proforma/listavendidos/excel'
                }
                axios
                .post(process.env.VUE_APP_API_URL + ruta, {
                    token: this.$store.getters.userToken,               
                    f1: date1,
                    f2: date2
                })
                .then(response => {
                    file = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'+ response.data.base64;
                    this.loadingexcelreport = false;
                    download(file, name,'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    this.$swal.close()
                })
                .catch(error => {
                    this.loadingexcelreport = false;
                    this.$swal.close();
                    console.log(error)
                })
            },
            customFormatter: function (date) {
                return this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
            },
            initDates: function () {
                this.f1 = this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
                this.f2 = this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
                this.currentdate = this.$moment().format('YYYY-MM-DD HH:mm:ss');
            },
            onFiltered (filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1
            },
            selectorRuta: function () {
                if(this.selected === 1){
                this.listaProductos(1)
                }else if(this.selected === 2) {
                    this.listaProductos(2)
                }else if(this.selected === 3) {
                    this.listaProductos(3)
                }else if(this.selected === 4){
                    this.listaProductos(4)
                }else if(this.selected === 5){
                     this.listaProductos(5)
                }else if(this.selected === 6){
                   this.listaProductos(6) 
                }else if(this.selected === 7){
                   this.listaProductos(7) 
                }else if(this.selected === 8){
                   this.listaProductos(8) 
                }else if(this.selected === 9){
                   this.listaProductos(9) 
                }
            },
            listaProductos: function (opt) {
                let ruta = '';
                let fecha1 = this.$moment().format('YYYY-MM-DD HH:mm:ss');
                let fecha2 = this.$moment().format('YYYY-MM-DD HH:mm:ss');
                switch(opt){
                    case 1: 
                        ruta = 'reporteitem/conteototal';
                        this.tabtable = 1;
                        break; 
                    case 2: 
                        ruta = 'reporteitem/poritemnombre';
                        this.tabtable = 1;
                        break; 
                    case 3: 
                        ruta = 'reporteitem/listavendidos';
                        this.tabtable = 2;
                        break;
                    case 4: 
                        ruta = 'reporteitemguia/conteototal';
                        this.tabtable = 3;
                        break;
                    case 5: 
                        ruta = 'reporteitemguia/poritemnombre';
                        this.tabtable = 3;
                        break;
                    case 6: 
                        ruta = 'reporteitemguia/lista';
                        this.tabtable = 4;
                        break;
                    case 7: 
                        ruta = 'reporteitem/proforma/conteototal';
                        this.tabtable = 7;
                        break; 
                    case 8: 
                        ruta = 'reporteitem/proforma/poritemnombre';
                        this.tabtable = 7;
                        break; 
                    case 9: 
                        ruta = 'reporteitem/proforma/listavendidos';
                        this.tabtable = 9;
                        break;          
                }
                if(this.f1 !== '' || this.f2 !== ''){
                    this.f1 === '' ? fecha1 = this.$moment().format('YYYY-MM-DD HH:mm:ss'): fecha1 = this.$moment(this.f1).format('YYYY-MM-DD HH:mm:ss');
                    this.f2 === '' ? fecha2 = this.$moment().format('YYYY-MM-DD HH:mm:ss'): fecha2 = this.$moment(this.f2).format('YYYY-MM-DD HH:mm:ss')
                }
                this.isBusy = true;
                axios
                .post(process.env.VUE_APP_API_URL + ruta, {
                    token: this.$store.getters.userToken,
                    order: 'desc',
                    page: this.currentPage,
                    limit: this.limite,
                    f1: fecha1,
                    f2: fecha2
                })
                .then(response => (
                    this.checkResponse(response.data, opt)
                ))
                .catch(error => {
                    this.isBusy = false;
                    console.log(error)
                })
            },
            checkResponse: function (data, opt) {
                if(opt===1){
                    this.interceptVendidos(data)
                }else{
                    this.items = data.data;
                    this.totalRows = this.items.length;
                    this.total = data.total;
                    this.desde = data.from;
                    this.hasta = data.to;
                    this.isBusy = false
                }
            },
            interceptVendidos: function (data) {
                this.items = [];
                if(data.data.length > 0){
                    for (let i=0; i<data.data.length; i++) {
                        if(data.data[i].idProducto === "-"){
                            data.data[i].descripcion = 'SUMATORIA CONSOLIDADA DE PRODUCTOS SIN CÓDIGO ...'
                        }
                        this.items.push(data.data[i])
                    }
                    this.isBusy = false;
                    this.totalRows = this.items.length;
                    this.total = data.total;
                    this.desde = data.from;
                    this.hasta = data.to
                }else {
                    this.isBusy = false
                }
            },
            itemsPrecioUni(value){
                let valor
                value.infoDocumento.proforma.items.forEach(element => {
                    if(value.descripcion == element.descripcion){
                        valor = element.precioVentaUnitario
                    }
                });

                return valor
            }
        } 
    }
</script>
